/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: jordan.lu jordan.lu@oppo.com
 * @LastEditTime: 2024-05-27 14:40:21
 * @FilePath: \community-backendf:\community-frontend\src\router\index.js
 */
import pinia from '@/stores/store';
import pcRoutes from './webRoutes'
import mobileRoutes from './wapRoutes'
import http from '@/service'
import App from '@/App.vue'
import QS from 'qs'

import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { useSystemStore } from '@/stores/system'
import { useSearchStore } from '@/stores/search'
import { useNavigationStore } from '@/stores/navigation'
import { storeToRefs } from 'pinia';
import { toast } from '@/utils/ui'
import { getQueryVariable } from '@/utils'
import vueI18n from '@/lang'
import jsBridge from '@/jsBridgeApi'

let routerInstance = null

const { global: { t }} = vueI18n


function createRouterInstance () {
  const app = createApp(App)
  app.use(pinia)

  const systemStore = useSystemStore()
  const searchStore = useSearchStore()
  const navigationStore = useNavigationStore()
  const { visible, wapVisible } = storeToRefs(searchStore)
  const { isMyOppo, isOneplus, isOppoApp, versionCode, customSetting } = storeToRefs(systemStore)

  // 记录滚动条
  const scrollBehavior = (to, from, savedPosition) => {
    return savedPosition ? savedPosition : { left: 0, top: 0 }
  }

  // pc路由、wap路由
  const routes = window.innerWidth >= 1024 ? pcRoutes() : mobileRoutes();
  
  routerInstance = createRouter({
    routes,
    scrollBehavior,
    history: createWebHistory(import.meta.env.BASE_URL),
  })
  
  routerInstance.beforeEach(async (to, from, next) => {

    // const userStore = useUserStore()
    // const { isBetaUser, uid } = storeToRefs(userStore)
    const betaPageList = ['milestones', 'inspirationPath', 'milestonesBenefits', 'inspirationPathBenefits', 'milestonesDetails', 'inspirationPathDetails']
    let query = { ...to.query }
    // 切换页面关闭搜索窗口
    if (to.name !== from.name) {
      visible.value = false
      wapVisible.value = false
    }
    let verifyCode = getQueryVariable('code')
    // 账号中心验证码校验，code为账号中心拼接
    if (verifyCode) {
      const params = {code: verifyCode}
      // app登录中转页需要携带appCode请求头
      let fromTransPage = getQueryVariable('fromTransPage')
      if (fromTransPage === 'login') {
        params.appCode = 'community_app'
      }
      const { code, data, msg } = await http.getTicket(params)
      // 移除验证码
      let query = getQueryVariable()
      if (query.code) {
        delete query.code
      }
      query = `${Object.keys(query)?.length ? '?' : ''}${QS.stringify(query)}`
      const path = `${location.origin}${location.pathname}${query}`
      if (code === 200 && data) {
        setTimeout(() => {
          location.replace(path)
        }, 200);
      } else {
        // 登录失败
        toast({
          message: t('nova_community_login_failed'),
          onClose: () => {
            location.replace(path)
          }
        })
      }
      return false
    }
    // 登出，logOut为账号中心登出时orbit社区的回调地址上拼接
    if (to.query.logOut) {
      const { code, data, msg} = await http.clearTicket()
      delete query.logOut
      let path = `${location.origin}${to.path}?${QS.stringify(query)}`
      if (code === 200) {
        setTimeout(() => {
          location.replace(path)
        }, 200);
      } else {
        // 登出失败
        toast({
          message: t('logoutFail'),
          onClose: () => {
            location.replace(path)
          }
        })
      }
      return false
    }

    if (betaPageList.includes(to.name) && !customSetting.value.membershipSwitch) {
      location.replace(location.origin)
      return false
    }
    // 1+旧社区地址重定向
    let pathNameREG = new RegExp(/\/threads.*?\d+/)
    if (pathNameREG.test(location.pathname)) {
      let threadIdReg = location.pathname.match(/\.\d+/) || []
      if (threadIdReg[threadIdReg.length - 1]) {
        let threadId = threadIdReg[threadIdReg.length - 1].match(/\d+/)[0]
        location.replace(`${location.origin}/thread/${threadId}`)
        return false
      }
      return false
    }
    // 处理myoppo首页tab栏加载的社区页面并不是H5全容器，会导致系统侧滑手势退出app，键盘拉起评论窗小时问题
    if (isMyOppo.value && from.query.webViewType === 'inject') {
      const path = `${to.fullPath}${to.fullPath.includes('?') ? '&' : '?'}isHideToolbar=true`
      jsBridge.openNewWebview(`${location.origin}${path}`)
      return false
    }
    // 由于POC也是Person of Color(有色人种)的缩写，被投诉涉嫌歧视，故把poc链接换成product
    if (to.name === 'poc') {
      next({
        path: to.path.replace('/poc', '/product'),
        query,
        params: to.params
      })
      return false
    }
    // 旧链接id参数转为伪静态链接
    if (query.id) {
      let id = query.id
      delete query.id;
  location.replace(`${location.origin}${to.path}/${id}${Object.keys(query).length ? `?${QS.stringify(query)}` : ''}`)
      return false
    }
    // 旧项目移动端链接移除wap路径
    if (to.path.includes('wap')) {
      next({
        path: to.path.replace('/wap', ''),
        query,
        params: to.params
      })
      return false
    }
    // 1+app新版本poc跳转发布器原生页
    if ((isOneplus.value || isOppoApp.value) && Number(versionCode.value) >= 41700 && to.path.includes('post')) {
      const { query: linkParams, params } = to
      let threadType = 1
      switch (params.type) {
        case 'article':
          threadType = 1
          break
        case 'moment':
          threadType = 2
          break
        case 'poll':
          threadType = 4
          break
        default:
          threadType = 1
      }
      const data = {
        threadType,
        threadId: params.id
      }
      if (linkParams && Object.keys(linkParams).length) {
        if (linkParams.circleId) {
          data.circleId = linkParams.circleId
        }
        if (linkParams.circleTabId) {
          data.circleTabId = linkParams.circleTabId
        }
        if (linkParams.from) {
          data.type = linkParams.from === 'product' ? 'pocIdeas' : ''
        }
      }
      jsBridge.openPostPage(data)
      return false
    }
    next()
  })

  routerInstance.afterEach(async (to, from) => {
    const { isAppMarket } = storeToRefs(systemStore)
    // 清空导航动态标题
    navigationStore.setNavigationTitle('')
    // 修改浏览器tab标题、描述
    document.title = to.meta.title || t(`${import.meta.env.VITE_COUNTRY}Title`)
    document.querySelector('meta[property="title"]').content = to.meta.title
    document.querySelector('meta[property="description"]').content = to.meta.description || t(`${import.meta.env.VITE_COUNTRY}Description`)
  })
}

function resetRouter () {
  const app = createApp(App)
  app.use(pinia)
  const systemStore = useSystemStore()
  const { browserType } = storeToRefs(systemStore)
  const resizeResult = window.innerWidth >= 1024 ? 'web' : 'wap'; // 根据需要调整断点
  createRouterInstance()
  if (resizeResult !== browserType.value) {
    location.reload()
  }
}


window.addEventListener('resize', resetRouter);

export { resetRouter, routerInstance }

